export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_1-7d9f4f825ec1a735933cda040517e612.jpg";